import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dacf8172"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "col-12 card d-flex flex-column p-0",
  style: {"font-size":"17px","overflow-x":"scroll"}
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<li style=\"border-radius:10px 10px 0px 0px;min-width:930px;border-bottom:0.5px solid #F3F3F3;\" class=\"col-12 p-5 d-flex flex-row header_list\" data-v-dacf8172><span class=\"m-0 col-2 d-flex justify-content-center subtitulo\" data-v-dacf8172>FIPE</span><span class=\"m-0 col-4 d-flex justify-content-center subtitulo\" data-v-dacf8172>MARCA</span><span class=\"m-0 col-4 d-flex justify-content-center subtitulo\" data-v-dacf8172>MODELO</span><span class=\"m-0 col-2 d-flex justify-content-center subtitulo\" data-v-dacf8172>ANO</span></li>", 1)
const _hoisted_3 = ["title"]
const _hoisted_4 = ["title"]
const _hoisted_5 = ["title"]
const _hoisted_6 = ["title"]
const _hoisted_7 = {
  key: 1,
  class: "d-flex align-items-center justify-content-center",
  style: {"min-height":"10rem"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"font-size":"medium","height":"24px","width":"24px"},
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...")
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 2,
  class: "d-flex justify-content-center align-items-center p-8 w-100 h-100"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 texto cor_texto_1" }, "Faça uma busca para encontrar veículos . . .", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 3,
  class: "d-flex justify-content-center align-items-center p-8 w-100 h-100"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 texto cor_texto_1" }, "Nenhum veículo encontrado . . .", -1))
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _hoisted_2,
    (!_ctx.loading)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.arrayVeiculos, (veiculo, key) => {
          return (_openBlock(), _createElementBlock("li", {
            key: key,
            class: "listaZebra col-12 d-flex flex-row align-items-center p-5",
            style: {"color":"#464e5f","min-width":"930px"}
          }, [
            _createElementVNode("div", {
              class: "col-2 text-truncate d-flex justify-content-center texto",
              title: veiculo.fipe || '-'
            }, _toDisplayString(veiculo.fipe || "-"), 9, _hoisted_3),
            _createElementVNode("div", {
              class: "col-4 text-truncate d-flex justify-content-center texto",
              title: veiculo.marca || '-'
            }, _toDisplayString(veiculo.marca || "-"), 9, _hoisted_4),
            _createElementVNode("div", {
              class: "col-4 text-truncate d-flex justify-content-center texto",
              title: veiculo.modelo || '-'
            }, _toDisplayString(veiculo.modelo || "-"), 9, _hoisted_5),
            _createElementVNode("div", {
              class: "col-2 text-truncate d-flex justify-content-center texto",
              title: veiculo.ano || '-'
            }, _toDisplayString(veiculo.ano || "-"), 9, _hoisted_6)
          ]))
        }), 128))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9)),
    (!_ctx.loading && _ctx.arrayVeiculos === null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
      : (!_ctx.loading && _ctx.arrayVeiculos.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
        : _createCommentVNode("", true)
  ]))
}